export type TCommunicationTaskStepId = 1 | 2 | 3;
export type TCommunicationTaskStepKey = "matching" | "changes" | "questions";
export type TCommunicationTaskStepStatus = "done" | "attention" | "optional" | "locked";
export type TCommunicationTaskStepIconKey = "check" | "attention" | "note" | "lock";

export type TCommunicationTaskStep = {
  id: TCommunicationTaskStepId;
  key: TCommunicationTaskStepKey;
  titleKey: string;
  descriptionKey: string;
  status: TCommunicationTaskStepStatus;
  icon: TCommunicationTaskStepIconKey;
  badgeTextKey: string;
  count: number;
  isClickable: boolean;
  blocksNext: boolean;
  blocksApprove: boolean;
};

type TBuildCommunicationTaskStepsParams = {
  isMatchComplete: boolean;
  stepTwoReviewCount: number;
  openQuestionsCount: number;
  hasReviewableChanges: boolean;
  isFinalized: boolean;
  maxUnlockedStep: TCommunicationTaskStepId;
};

export const buildCommunicationTaskSteps = ({
  isMatchComplete,
  stepTwoReviewCount,
  openQuestionsCount,
  hasReviewableChanges,
  isFinalized,
  maxUnlockedStep,
}: TBuildCommunicationTaskStepsParams): TCommunicationTaskStep[] => [
  {
    id: 1,
    key: "matching",
    titleKey: "COMMUNICATION.Step_Matching_Title",
    descriptionKey: "COMMUNICATION.Step_Matching_Help",
    status: isMatchComplete ? "done" : "attention",
    icon: isMatchComplete ? "check" : "attention",
    badgeTextKey:
      isMatchComplete
        ? "COMMUNICATION.StepStatus_Ready"
        : "COMMUNICATION.StepStatus_NeedsMatch",
    count: 0,
    isClickable: true,
    blocksNext: !isMatchComplete,
    blocksApprove: !isMatchComplete,
  },
  {
    id: 2,
    key: "changes",
    titleKey: "COMMUNICATION.Step_Changes_Title",
    descriptionKey: "COMMUNICATION.Step_Changes_Help",
    status:
      maxUnlockedStep < 2 && !isFinalized
        ? "locked"
        : maxUnlockedStep >= 3 || isFinalized
          ? "done"
          : stepTwoReviewCount > 0
            ? "attention"
            : "optional",
    icon:
      maxUnlockedStep < 2 && !isFinalized
        ? "lock"
        : maxUnlockedStep >= 3 || isFinalized
          ? "check"
          : stepTwoReviewCount > 0
            ? "attention"
            : "note",
    badgeTextKey:
      maxUnlockedStep < 2 && !isFinalized
        ? "COMMUNICATION.StepStatus_CompleteStep1First"
        : stepTwoReviewCount > 0
          ? "COMMUNICATION.StepStatus_ReviewCount"
          : hasReviewableChanges
            ? maxUnlockedStep >= 3 || isFinalized
              ? "COMMUNICATION.StepStatus_Reviewed"
              : "COMMUNICATION.StepStatus_NoPending"
            : "COMMUNICATION.StepStatus_NoExtractedChanges",
    count: stepTwoReviewCount,
    isClickable: isFinalized || maxUnlockedStep >= 2,
    blocksNext: false,
    blocksApprove: false,
  },
  {
    id: 3,
    key: "questions",
    titleKey: "COMMUNICATION.Step_Questions_Title",
    descriptionKey: "COMMUNICATION.Step_Questions_Help",
    status:
      maxUnlockedStep < 3 && !isFinalized
        ? "locked"
        : isFinalized
          ? "done"
        : "optional",
    icon:
      maxUnlockedStep < 3 && !isFinalized
        ? "lock"
        : isFinalized
          ? "check"
        : "note",
    badgeTextKey:
      maxUnlockedStep < 3 && !isFinalized
        ? "COMMUNICATION.StepStatus_CompleteStep2First"
        : openQuestionsCount > 0
          ? "COMMUNICATION.StepStatus_FinalCheck"
          : "COMMUNICATION.StepStatus_ReadyToApprove",
    count: 0,
    isClickable: isFinalized || maxUnlockedStep >= 3,
    blocksNext: false,
    blocksApprove: false,
  },
];
